import { Flex, Typography, TruncateMarkup, Image } from 'shared';

import { LinkPreviewPropTypes } from 'features/chat/config/types/LinkPreview';
import { useChatMessageContext } from 'features/chat/context/chatMessage';

import { extractDomainName } from 'shared/utils/links';

export const ChatMessageLinkPreviewUploaded = ({
  title,
  description,
  image,
  url,
}: LinkPreviewPropTypes) => {
  const { isIncoming } = useChatMessageContext();

  const domainName = extractDomainName(url);

  const textColor = isIncoming ? 'blackTotal' : 'whiteTotal';

  return (
    <a href={url} target="_blank" rel="noreferrer">
      {image && (
        <Image
          alt="web site"
          src={image}
          data-testid="link-preview-image"
          height="160px"
          objectFit="cover"
          display="block"
        />
      )}
      <Flex gap="0.5rem" flexDirection="column" p="8px" width="100%">
        <Typography fontWeight="semibold" type="body" color={textColor}>
          {title}
        </Typography>
        <Typography type="meta" color={textColor}>
          <TruncateMarkup lines={2} ellipsis={<span>...</span>}>
            <span>{description}</span>
          </TruncateMarkup>
        </Typography>
        <Typography type="meta" fontWeight="medium" color={textColor}>
          {domainName}
        </Typography>
      </Flex>
    </a>
  );
};
